import { useState } from 'react';
import Modal from '@/components/ui/Modal';
import Input from '@/components/ui/Input';
import Button from '@/components/ui/Button';
import type { WineSummary } from '@/api/wines';

interface AddToCellarModalProps {
  wine: WineSummary | null;
  open: boolean;
  onClose: () => void;
  onAdd: (entry: CellarFormData) => Promise<void>;
}

export interface CellarFormData {
  wineId: string;
  quantity: number;
  purchasePrice?: number;
  purchaseDate?: string;
  drinkFrom?: string;
  drinkBy?: string;
  location?: string;
  notes?: string;
}

export default function AddToCellarModal({ wine, open, onClose, onAdd }: AddToCellarModalProps) {
  const [quantity, setQuantity] = useState('1');
  const [purchasePrice, setPurchasePrice] = useState('');
  const [purchaseDate, setPurchaseDate] = useState('');
  const [drinkFrom, setDrinkFrom] = useState('');
  const [drinkBy, setDrinkBy] = useState('');
  const [location, setLocation] = useState('');
  const [notes, setNotes] = useState('');
  const [saving, setSaving] = useState(false);

  async function handleAdd() {
    if (!wine) return;
    setSaving(true);
    await onAdd({
      wineId: wine.id,
      quantity: parseInt(quantity) || 1,
      purchasePrice: purchasePrice ? parseFloat(purchasePrice) : undefined,
      purchaseDate: purchaseDate || undefined,
      drinkFrom: drinkFrom || undefined,
      drinkBy: drinkBy || undefined,
      location: location || undefined,
      notes: notes || undefined,
    });
    setSaving(false);
    onClose();
  }

  return (
    <Modal open={open} onClose={onClose} title={`Add to cellar — ${wine?.name ?? ''}`}>
      <div className="cellar-form">
        <Input label="Quantity" type="number" min="1" value={quantity} onChange={(e) => setQuantity(e.target.value)} />
        <Input label="Purchase price (R)" type="number" value={purchasePrice} onChange={(e) => setPurchasePrice(e.target.value)} placeholder="Optional" />
        <Input label="Purchase date" type="date" value={purchaseDate} onChange={(e) => setPurchaseDate(e.target.value)} />
        <Input label="Drink from" type="date" value={drinkFrom} onChange={(e) => setDrinkFrom(e.target.value)} />
        <Input label="Drink by" type="date" value={drinkBy} onChange={(e) => setDrinkBy(e.target.value)} />
        <Input label="Location" value={location} onChange={(e) => setLocation(e.target.value)} placeholder="e.g. Garage rack, shelf 2" />
        <Input label="Notes" value={notes} onChange={(e) => setNotes(e.target.value)} placeholder="Optional" />
        <Button variant="primary" onClick={handleAdd} loading={saving} fullWidth>
          Add to cellar
        </Button>
      </div>
    </Modal>
  );
}
